import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import Home     from './Components/home/Home';
import Contact  from './Components/contact/Contact';
import Privacy  from './Components/privacy/Privacy';
import Footer   from './Components/global/Footer';

import './fonts/fonts.css';
function App() {
    return (
        <Router>
            <Route exact path="/"           component={Home} />
            <Route exact path="/contact"    component={Contact} />
            <Route exact path="/privacy"    component={Privacy} />
            <Footer />
        </Router>
    );
}

export default App;
